module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.caseData) ? _c('div', [
    [_c('v-tabs', {
      attrs: {
        "color": "#e1e1e1"
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
      key: 1,
      staticClass: "primary--text",
      attrs: {
        "ripple": ""
      }
    }, [_vm._v("\n          Client Details\n        ")]), _vm._v(" "), _c('v-tab', {
      key: 2,
      staticClass: "primary--text",
      attrs: {
        "ripple": "",
        "disabled": !_vm.tab2active
      }
    }, [_vm._v("\n          Packages and Vendors\n        ")])], 1), _vm._v(" "), _c('v-tabs-items', {
      attrs: {
        "touchless": ""
      },
      model: {
        value: (_vm.tab),
        callback: function($$v) {
          _vm.tab = $$v
        },
        expression: "tab"
      }
    }, [_c('v-tab-item', {
      key: 1
    }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', [_vm._v("Next-of-Kin's Details")])])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-radio-group', {
      staticClass: "large-radio",
      attrs: {
        "large": "",
        "column": false
      },
      model: {
        value: (_vm.clientRelation),
        callback: function($$v) {
          _vm.clientRelation = $$v
        },
        expression: "clientRelation"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": 'Returning Customer',
        "value": 'returning'
      }
    }), _vm._v(" "), _c('v-radio', {
      attrs: {
        "label": 'New Customer',
        "value": 'new'
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-subheader', {
      staticClass: "required"
    }, [_vm._v("Client (Next of Kin):")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('dfs-client-add-form', {
      attrs: {
        "selected-client": _vm.selectedClient,
        "client-name": _vm.caseData && _vm.caseData.client && _vm.caseData.client.name
      },
      on: {
        "namechanged": _vm.onNameChanged,
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('dfs-forms', {
      attrs: {
        "caseid": _vm.caseid
      },
      on: {
        "valid:changed": _vm.onFormValidate
      }
    })], 1)], 1), _vm._v(" "), _c('DfsServiceAgreementCheckList', {
      on: {
        "agreement:status": _vm.checkAgreementStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), _c('DfsServiceAgreementClientData', {
      attrs: {
        "clientName": _vm.clientName,
        "newreturn": _vm.clientRelation
      },
      on: {
        "clientdata:input": _vm.checkClientDataStatus,
        "valid:changed": _vm.onFormValidate
      }
    }), _vm._v(" "), (!_vm.caseData.client_signature) ? _c('div', [_c('h3', {
      staticClass: "required"
    }, [_vm._v("Draw Client Signature")]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "top": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": "",
        "icon": ""
      },
      on: {
        "click": _vm.clearSignature
      },
      slot: "activator"
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("undo")])], 1), _vm._v("\n                  Clear signature\n                ")], 1), _vm._v(" "), _c('div', {
      staticClass: "sign-pad"
    }, [_c('VueSignaturePad', {
      ref: "signaturePad",
      attrs: {
        "height": "250px",
        "width": "500px"
      }
    })], 1)], 1) : _c('div', [_c('h3', {
      staticClass: "required"
    }, [_vm._v("Client Signature")]), _vm._v(" "), _c('v-img', {
      attrs: {
        "src": _vm.caseData.client_signature
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": "",
        "loading": _vm.loading.SaveCaseBtn,
        "disabled": _vm.disabled.SaveCaseBtn
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveCase($event)
        }
      }
    }, [_vm._v("\n                Save case\n              ")])], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
      attrs: {
        "open": _vm.dialogOpen,
        "message": _vm.dialogMessage
      },
      on: {
        "closedialog": function($event) {
          _vm.dialogOpen = false
        }
      }
    })], 1), _vm._v(" "), _c('v-tab-item', {
      key: 2
    }, [_c('SelectPlanAndVendors', {
      attrs: {
        "caseData": _vm.caseData,
        "case-id": _vm.caseid,
        "editable": ""
      }
    })], 1)], 1)], _vm._v(" "), _c('ConfirmationDialog', {
      ref: "confirm"
    }), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "hide-overlay": "",
        "persistent": "",
        "width": "300"
      },
      model: {
        value: (_vm.showAlert),
        callback: function($$v) {
          _vm.showAlert = $$v
        },
        expression: "showAlert"
      }
    }, [_c('v-card', {
      attrs: {
        "color": "primary",
        "dark": ""
      }
    }, [_c('v-card-text', {
      staticClass: "flex-alert-center"
    }, [_c('v-icon', {
      staticClass: "flex-alert-notification-check",
      attrs: {
        "dark": "",
        "right": ""
      }
    }, [_vm._v("error")]), _vm._v(" " + _vm._s(_vm.alertMessage) + "\n        ")], 1)], 1)], 1)
  ], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d076e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnboardClient.vue
// module id = 971
// module chunks = 1